import { Grid, SelectField, TextAreaField, TextField } from "../Fields";
import { FAMILY_TYPES } from "../../../lib/options";

export default function StepFamily() {
  return (
    <Grid>
      <TextField section="family" name="father_name" label="Father's name" required />
      <TextField section="family" name="mother_name" label="Mother's name" required />
      <TextField section="family" name="father_occupation" label="Father's occupation" />
      <TextField section="family" name="mother_occupation" label="Mother's occupation" />
      <SelectField section="family" name="family_type" label="Type of family" required options={FAMILY_TYPES} />
      <TextField section="family" name="siblings" label="Siblings" placeholder="e.g. 1 brother, 1 sister" />
      <TextField section="family" name="married_siblings" label="Married siblings" placeholder="e.g. 1 sister married" />
      <TextAreaField section="private" name="nearest_relative_residence" label="Nearest relative's residence" className="sm:col-span-2" hint="Kept private, visible only to our office." />
    </Grid>
  );
}
